(function (appComponents) {

	// move product collections to be controlled from this service

	appComponents.services.productBase = function (Components) {

		var productBase = {};

		productBase.name = "productBase";

		Components.getComponentPrototype().extend(productBase);
		productBase._helpers = productBase._getService("helpers");


		productBase.elements = {

		};

		productBase.bindings = function () {};

		productBase.showDetails = function (product) {
			productBase._stash.selectedProduct = product;
			var pageData = productBase._pages.productDetails;
			productBase._handlers.onSoftSwitchToPage(pageData);
		};

		productBase.downloadDataPack = function (stockId, type) {
			var baseUrl;
			var queryObject;
			switch (type) {
				case "word":
					baseUrl = productBase._url.dataPack.word;
					queryObject = {
						code: stockId + "_DATAPACK",
					};
					break;
				case "pdf":
					baseUrl = productBase._url.dataPack.pdf;
					queryObject = {
						code: stockId + "_DATAPACK",
					};
					break;
				default:
					baseUrl = productBase._url.dataPack.base;
					queryObject = {
						code: stockId + "_" + type,
					};
					break;
			}
			var query = $.param(queryObject);
			var url = baseUrl + query;

			productBase._helpers.clickAnchorLink(url);
		};

		productBase.downloadArchive = function (stockId, codes) {
			var baseUrl;
			var codesArray = [];
			var queryObject;
			baseUrl = productBase._url.dataPack.archive;
			for (code in codes) {
				codesArray.push(stockId + "_" + code);
			}

			queryObject = {
				codes: codesArray.toString()
			};

			var query = $.param(queryObject);

			var url = baseUrl + query;

			productBase._helpers.clickAnchorLink(url);
		};

		productBase.handlers = {

		};

		productBase.init = function () {

			productBase._bindings();

		};

		return productBase;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});